"use strict";
//使用:
//1、import tips  
//2、tips.toast(msg)  msg是string;
 function ToastPopup(){
    this.config={
        timeout:2200,
        default:`position: fixed;
                left: 50%;
                top:50%;
                z-index: 1001;
                transform: translate(-50%,-50%) translate3d(0, 0, 0);
                max-width: 90%;
                padding: 8px 16px;
                line-height: 1.5;
                background-color: rgba(0,0,0,.8);
                color: #fff;
                border-radius: 6px;
                transition: opacity 0.3s ease-in;
                opacity: 0;`,
    }
    this.show=false;
    this.time=null;
    this.body=document.getElementsByTagName('body')[0];
}
ToastPopup.prototype={
    toast:function(msg){
        var _this=this;
        if(this.show){
            clearTimeout(this.time);
            console.log('thisthisthisthisthis-1',this.show);   

            var getwrap=document.getElementById('esToast');
            getwrap.innerHTML=`<div>`+msg+`</div>`;
            this.time=setTimeout(function(){
                _this.body.removeChild(getwrap);
                _this.show=false;
            },this.config.timeout);

        }else{

            var wrap=document.createElement('div');
            wrap.id="esToast";
            wrap.innerHTML=`<div>`+msg+`</div>`;;
            //wrap.style=_this.config.default;
            wrap.style.position='fixed';
            wrap.style.left='50%';
            wrap.style.top='50%';
            wrap.style.zIndex='1001';
            wrap.style.transform='translate(-50%,-50%) translate3d(0, 0, 0)';
            wrap.style.maxWidth='90%';
            wrap.style.padding='8px 16px';
            wrap.style.fontSize='16px';
            wrap.style.lineHeight='1.5';
            wrap.style.background='rgba(0,0,0,.8)';
            wrap.style.color='#fff';
            wrap.style.borderRadius='6px';
            wrap.style.transition='opacity 0.3s ease-in';
            wrap.style.opacity='0';
            this.body.appendChild(wrap);
            console.log('thisthisthisthisthis-2',this.show);   

            setTimeout(function(){
                wrap.style.opacity=1;
                _this.show=true;
            },0);
            this.time=setTimeout(function(){
                _this.body.removeChild(wrap);
                _this.show=false;
            },this.config.timeout);
        }
    }
}
const tips=new ToastPopup();
export default tips;




// WEBPACK FOOTER //
// ./src/estoast/index.js